/** @type {import('../help-index.js').HelpSidebarItem} */
export const ACC_LIB_LEDGER_ITEM = {
  id: 'ledger',
  screenId: 'acc-lib-ledger',
  label: 'Mayor',
  description: 'Movimientos por cuenta con saldo acumulado.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Libro mayor: movimientos de una o todas las cuentas con saldo corrido (debe, haber, saldo).',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Desde / Hasta', description: 'Período a consultar.' },
          { label: 'Cuenta contable', description: 'Opcional. Vacío = todas las cuentas con movimiento.' },
        ],
      },
      {
        title: 'Paso 2 — Resultados',
        bullets: [
          'Columnas: cuenta, fecha, asiento, concepto, debe, haber, saldo.',
          'Exportar CSV o Excel.',
        ],
      },
    ],
  },
}
